var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-app",
    {
      staticStyle: { height: "100vh" },
      attrs: { id: "cfg-demenego", dark: _vm.appDark },
    },
    [
      _c("div", { staticClass: "app-content" }, [
        _c(
          "div",
          {
            staticClass: "content-inner",
            staticStyle: {
              "background-color": "white",
              display: "flex",
              "flex-direction": "column",
            },
          },
          [
            _c("link", {
              attrs: {
                rel: "stylesheet",
                type: "text/css",
                href: "https://thema-optical.com/css/thema-font/thema-font.css",
              },
            }),
            _c("link", {
              attrs: {
                rel: "stylesheet",
                type: "text/css",
                href: "https://thema-optical.com/css/thema-font/thema-font-codes.css",
              },
            }),
            _c("link", {
              attrs: {
                rel: "stylesheet",
                type: "text/css",
                href: "https://thema-optical.com/css/thema-font/thema-font-embedded.css",
              },
            }),
            _c("Configurator", {
              ref: "configurator",
              attrs: { isFullScreen: _vm.isFullscreen, darkTheme: _vm.appDark },
              on: {
                "open-first-page": function ($event) {
                  _vm.menuOpen = true
                },
              },
            }),
            !_vm.itemsLoaded
              ? _c(
                  "div",
                  { staticClass: "container-loading" },
                  [_c("Loading")],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      !_vm.isConfigMode && _vm.$vuetify.breakpoint.lgAndUp
        ? _c(
            "v-btn",
            {
              staticClass: "fullscreen-btn",
              attrs: { fab: "", small: "" },
              on: { click: _vm.toggleFullscreen },
            },
            [
              _c("v-icon", [
                _vm._v(
                  _vm._s(_vm.isFullscreen ? "fullscreen_exit" : "fullscreen")
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      !_vm.isConfigMode && _vm.$vuetify.breakpoint.lgAndDown
        ? _c(
            "v-btn",
            {
              staticClass: "fullscreen-btn2",
              attrs: { fab: "", small: "" },
              on: { click: _vm.toggleFullscreen },
            },
            [
              _c("v-icon", [
                _vm._v(
                  _vm._s(_vm.isFullscreen ? "fullscreen_exit" : "fullscreen")
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }